console.log( "///////////////RVAR LOCAL" );

var PRODUCT_CARD_TEMPLATE = 
`
<div class="we-product-card-wrapper snize-thumbnail-wrapper snize-product rv-product-card-target rv-product-card" id="snize-product-6929207623864">
            <div class="icon_wrapper">
                <button type="button" aria-label="Add to wishlist" class="button--wishlist lightning-wishlist-control" data-product="6929207623864" button-wishlist="" data-product-handle="hu-organic-hazelnut-butter-dark-chocolate-bar-60g" fdprocessedid="ka5bb">
                    <svg class="icon icon-heart " viewBox="0 0 290 256" xmlns="http://www.w3.org/2000/svg"><path d="M258.844192 127.790368L145 241.63456 31.1558082 127.790368c-26.9461761-26.946176-26.9461761-70.6345598 0-97.5807359 26.9461762-26.94617613 70.6345598-26.94617613 97.5807358 0L145 46.4730881l16.263456-16.263456c26.946176-26.94617613 70.63456-26.94617613 97.580736 0 26.946176 26.9461761 26.946176 70.6345599 0 97.5807359z" stroke="#000" stroke-width="20" fill="red" fill-rule="evenodd"></path></svg>
                </button>
            </div>
            <div class="we-product-card">
                <a class="we-product-card-link" href="/products/hu-organic-hazelnut-butter-dark-chocolate-bar-60g" data-url="">
                    <div class="product-image-wrapper">
                        <img src="//welleasy.co.uk/cdn/shop/products/hu44.jpg?v=1633457967&amp;width=250" class="product-card-image" alt="Featured image" width="160" height="auto" data-featured-image="" data-product-img>
                    </div>
                    <div class="product-sticker-wrap">
                        <span class="product-sticker"><span data-percentage-difference=""></span>% off</span>
                    </div>
                    <div class="product-text-wrap">
                        <p class="p-margin" data-product-title="" data-product-title></p>
                    </div>
                </a>

                <div class="ruk_rating_snippet" data-sku="" rating-snippet-batch="0" style="color: rgb(245, 196, 155);" data-retrieved="true" title="4.78 Stars - 18 Reviews" data-done="true"><i aria-hidden="true" class="ruk-icon-percentage-star--100"></i><i aria-hidden="true" class="ruk-icon-percentage-star--100"></i><i aria-hidden="true" class="ruk-icon-percentage-star--100"></i><i aria-hidden="true" class="ruk-icon-percentage-star--100"></i><i aria-hidden="true" class="ruk-icon-percentage-star--75"></i><span class="ruk-rating-snippet-count" style="color: rgb(51, 51, 51);">(18 Reviews)</span></div>
                
                <a href="/products/hu-organic-hazelnut-butter-dark-chocolate-bar-60g" data-url2="">
                    <div style="height: 30px;">
                        <p class="p-margin" data-vendor="" data-product-vendor>Hu</p>
                    </div>
                    <div class="price-wrap">
                        <p class="p-margin" data-price="" data-product-price>£2.75</p>
                        <p class="p-margin" style="text-decoration: line-through; color: lightgrey;" data-compare-price="" data-product-compare-price>£3.79</p>
                    </div>
                </a>
                <div class="snize-add-to-cart-button myAisleAddToCart" data-product="" data-first-variant="" style="display: none;">
                    Add to Cart
                </div><button class="add-to-cart-new snize-button">Add to cart</button>
            </div>
        </div>
`

function CreateOneRVARCustomProductSlide( widget, product, products )
{
    var productAvailable = true;
    if( products[ product.id ].product.available == false )
    {
        productAvailable == false;
    }
    if( ( products[ product.id ] ) && ( products[ product.id ].product ) && ( productAvailable ) && NotHiddenViaTag( products[ product.id ].product ) )
    {
        var template    = RVARConvertStringToHTML( PRODUCT_CARD_TEMPLATE, '.rv-product-card-target' );

        console.log( products[ product.id ].product );

        var fullProductData = products[ product.id ].product;
        var variants        = fullProductData.variants;
        var skus            = [];
        var productType     = fullProductData.product_type;
        var productTags     = fullProductData.tags;

        if( !productType && fullProductData.type )
        {
            productType = fullProductData.type;
        }
        if( productType )
        {
           productType = productType.toLowerCase(); 
        }

        if( typeof productTags == "string" )
        {
            productTags = fullProductData.tags.split( "," );
        }

        variants.forEach( function( variant )
        {
            skus.push( variant.sku );
        } );

        var templateID      = widget.title.replace( " ", "_" ) + "__" + fullProductData.id;
        var anchors         = template.querySelectorAll( "[data-product-url]" );
        anchors.forEach( function( anchor )
        {
            anchor.setAttribute( "href", "/products/" + fullProductData.handle )
        } );

        var featuredImageEl   = template.querySelector( "[ data-product-img ]" );
        var featuredImage     = fullProductData.images[ 0 ];
        if( fullProductData.media && fullProductData.media.length > 0 )
        {
            featuredImage     = fullProductData.media[ 0 ];
        }
        var featuredImageAlt  = featuredImage.alt;
        if( featuredImageAlt == "" )
        {
            featuredImageAlt = fullProductData.title;
        }
        featuredImageEl.setAttribute( "height", featuredImage.height );
        featuredImageEl.setAttribute( "width", featuredImage.width );
        featuredImageEl.setAttribute( "src", featuredImage.src + "&width=533" );
        featuredImageEl.setAttribute( "srcset", featuredImage.src + "&width=360" + " 360w," + featuredImage.src + "&width=533" + " 533w," + featuredImage.src + "&width=720" + " 720w," );

        var productTitleEl          = template.querySelector( "[ data-product-title ]" );
        productTitleEl.innerText    = fullProductData.title;
        productTitleEl.setAttribute( "id", templateID );

        var productPricesEl         = template.querySelectorAll( "[ data-product-price ]" );
        var productPrice            = variants[ 0 ].price;
        var compareAtPrice          = variants[ 0 ].compare_at_price;
        if( typeof productPrice == "string" && productPrice.includes( "." ) )
        {
            productPrice = Number( productPrice ) * 100;
        }

        if( typeof compareAtPrice == "string" && compareAtPrice && compareAtPrice.includes( "." ) )
        {
            compareAtPrice = Number( compareAtPrice ) * 100;
        }

        var pricePercentageDifference = Math.floor( ( 1 - ( productPrice / compareAtPrice ) ) * 100 );
        var differenceSticker         = template.querySelector( "[ data-percentage-difference ]" );
        differenceSticker.innerText   = pricePercentageDifference;

        productPricesEl.forEach( function( productPriceEl )
        {
            productPriceEl.innerText = new Intl.NumberFormat( window.Shopify.locale, { "style" : "currency", "currency" : window.Shopify.currency.active } ).format( ( productPrice / 100 ) );
        } );

        if( fullProductData.compare_at_price )
        {
            var productCompareAtPriceEl = template.querySelectorAll( "[ data-product-compare-price ]" );
            productCompareAtPriceEl.forEach( function( productPriceEl )
            {
                productPriceEl.innerText = new Intl.NumberFormat( window.Shopify.locale, { "style" : "currency", "currency" : window.Shopify.currency.active } ).format( ( compareAtPrice / 100 ) );
            } );
        }

        var productVendorEl = template.querySelector( "[data-product-vendor]" );
        productVendorEl.innerText = fullProductData.vendor;

        var anchors = template.querySelectorAll( "a" );
        if( anchors && anchors.length > 0 )
        {
            anchors.forEach( function( anchor ) 
            {
                anchor.setAttribute( "href", fullProductData.url );
            } );
        }

        var atcButton = template.querySelector( ".snize-add-to-cart-button" );
        atcButton.setAttribute( "data-product", fullProductData.id );
        atcButton.setAttribute( "data-first-variant", variants[ 0 ].id );

        var wishlistIcon = template.querySelector( ".lightning-wishlist-control" );
        wishlistIcon.setAttribute( "data-product", fullProductData.id );
        wishlistIcon.setAttribute( "data-product-handle", fullProductData.handle );

        var reviewSnippet = template.querySelector( ".ruk_rating_snippet" );
        if( reviewSnippet )
        {
            reviewSnippet.setAttribute( "data-sku", skus )
        }

        StartupSearchanizeOverride()
        return template;
    }
}